import {
  HttpEvent,
  HttpHandlerFn,
  HttpRequest,
  provideHttpClient,
  withInterceptors,
} from "@angular/common/http";
import { EnvironmentProviders, inject, Provider, provideEnvironmentInitializer } from "@angular/core";
import { httpInterceptor } from "./http.interceptor";
import { MatSnackBar } from "@angular/material/snack-bar";
import {
  FUSE_BYPASS_LOADING_BAR,
  fuseLoadingInterceptor,
  FuseLoadingService,
} from "@fuse/services/loading";
import { pendingRequestsInterceptor$ } from "ng-http-loader";
import { Observable } from "rxjs";

/**
 * Wraps ng-http-loader's interceptor so requests carrying
 * FUSE_BYPASS_LOADING_BAR also skip the global spinner overlay
 */
export const globalLoaderInterceptor = (
  req: HttpRequest<unknown>,
  next: HttpHandlerFn,
): Observable<HttpEvent<unknown>> => {
  if (req.context.get(FUSE_BYPASS_LOADING_BAR)) {
    return next(req);
  }
  return pendingRequestsInterceptor$(req, next);
};

export const provideHttpInterceptor = (): Array<
  Provider | EnvironmentProviders
> => {
  return [
    MatSnackBar /* add snackbar because its used by the interceptor */,
    provideHttpClient(
      withInterceptors([httpInterceptor, fuseLoadingInterceptor]),
    ),
    provideEnvironmentInitializer(() => inject(FuseLoadingService)),
  ];
};
